exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._229I--7_3_0 {\n  display: inline-block;\n  position: relative; }\n  ._1oAHM-7_3_0 {\n    bottom: 100%;\n    position: absolute;\n    right: 0;\n    transform: translateX(50%) translateY(50%); }\n", ""]);

// Exports
exports.locals = {
	"core-badge": "_229I--7_3_0",
	"core-badge__label": "_1oAHM-7_3_0"
};